import { EmployeeProfilesListTranslation } from '@/assets/locales/views/employeeProfilesList/employeeProfilesSearch.translation.en';

export const employeeProfilesListTranslation: EmployeeProfilesListTranslation = {
  content: {
    table: {
      department: 'Dział',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      position: 'Stanowisko',
      region: 'Region',
      regionArea: 'Okręg',
      regionDistrict: 'Rejon',
      sap: 'SAP',
    },
  },
  form: {
    button: {
      downloadDevelopmentPlans: 'Pobierz plany rozwojowe',
    },
    departments: 'Działy',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    myTeamOnly: 'Tylko mój zespół',
    positions: 'Stanowiska',
    regionAreas: 'Okręgi',
    regionDistricts: 'Rejony',
    regionsSelect: {
      east: 'Wschód',
      headquarter: 'Biuro główne',
      selectAll: 'Zaznacz wszystko',
      south: 'Południe',
      west: 'Zachód',
    },
    sap: 'SAP',
  },
  noViewPermission: 'Brak uprawnień do przeglądania profilu',
};
